// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"PodcastCard_cardBody__2ZhbV","cardTitle":"PodcastCard_cardTitle__O68Nm"};